import { render, staticRenderFns } from "./folders-counterparties-options.vue?vue&type=template&id=fbd6e68a&scoped=true"
import script from "./folders-counterparties-options.vue?vue&type=script&lang=js"
export * from "./folders-counterparties-options.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbd6e68a",
  null
  
)

export default component.exports